module.exports = __webpack_public_path__ + "img/giraffe.7d66f619.jpg";